import React from 'react';
import IRAContributionsEditor from '../IRAContributionsEditor/IRAContributionsEditor';
import RetailContributionsEditor from '../RetailContributionsEditor/RetailContributionsEditor';
import { isIRA } from '../../../../utils/IRA/IRA-utility';

const BuyFundEditor = (props) =>
  isIRA(props.fund) ? (
    <IRAContributionsEditor {...props} />
  ) : (
    <RetailContributionsEditor {...props} />
  );

export default BuyFundEditor;
